import React, { useEffect, useState } from "react";
import "./TeaserAggregatorForm.scss";
import { FixedHeader, PrimaryHeader, SecondaryHeader } from "../../ui/Header";
import ButtonGroup from "../../ui/ButtonGroup/ButtonGroup";
import Button from "../../ui/Button/Button";
import * as urls from "../../utils/urls";
import Select from "../../ui/Select/Select";
import CampaignsSelect from "../../components/CampaignsSelect";
import CampaignOverview from "../../ui/CampaignOverview/CampaignOverview";
import TeaserForm from "../../ui/TeaserForm/TeaserForm";
import TeaserCopyTo from "../../ui/TeaserCopyTo/TeaserCopyTo";
import {
  UrlImageUploadService,
  TeaserSaveService,
  SetCidWorkOnService,
  TeaserTitleGenerateService
} from "../../utils/api";

import useCampaignInfoEffect from "../../effects/useCampaignInfoEffect";

function isValid(fields) {
  return (
    !!fields.cid &&
    !!fields.category &&
    !!fields.title &&
    !!fields.image &&
    !!fields.url &&
    fields.type !== undefined &&
    fields.type !== null &&
    fields.type !== ""
  );
}

const TeaserAggregatorForm = ({
  item,
  onDone,
  currentItemNum,
  totalItemsNum
}) => {
  const [fields, setFields] = useState(item);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [aiTitles, setAiTitles] = useState({
    'titles': [],
    'keywords': []
  })
  const [aiTitlesLoading, setAiTitlesLoading] = useState(false)

  const {
    info: campaignInfo,
    loading: campaignInfoLoading
  } = useCampaignInfoEffect(fields.cid);

  const onChange = payload => {
    setFields({ ...fields, ...payload });
  };

  const onCampaignChange = selected => {
    setFields({ ...fields, cid: selected.value });
  };

  const handleSubmit = () => {
    setLoading(true);

    TeaserSaveService(fields)
      .then(() => {
        onDone();
      })
      .catch(e => {
        e.errors && setErrors(e.errors);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleTitleGenerate = () => {
    setAiTitlesLoading(true);

    TeaserTitleGenerateService(item.id)
      .then((data)=>{
        setAiTitles(data)
      })
      .finally(()=>{
        setAiTitlesLoading(false)
      })
  }
  
  useEffect(() => {
    if (fields.cid) {
      SetCidWorkOnService(fields.cid);
    }
  }, [fields.cid]);

  /*useEffect(() => {
        if (fields.image_url == null) {
            return;
        }

        UrlImageUploadService({ url: fields.image_url }).then(data => {
            setFields({ ...fields, image: "tmp/" + data.name });
        });
    }, [fields.image_url]);*/

  return (
    <div className="tagg-form">
      <FixedHeader className="tagg-form__header">
        <PrimaryHeader>
          <span className="header__title">Создание анонса</span>
          <ButtonGroup
            items={[
              { title: "Вручную", code: urls.teaserAdd(), exact: true },
              { title: "Агрегатор", code: urls.teaserAddAggregator() }
            ]}
            theme={"dark"}
            selected="add"
            nav
          />

          <span className="tagg-form__process">
            Обработано новостей: {currentItemNum} из {totalItemsNum}
          </span>

          <span className="tagg-form__skip-btn" onClick={onDone}>
            Пропустить
          </span>

          <Button
            className="tagg-form__create-btn"
            color="green"
            disabled={!isValid(fields)}
            onClick={handleSubmit}
          >
            Создать
          </Button>
        </PrimaryHeader>
        <SecondaryHeader>
          <div className="tagg-form__controls">
            <CampaignsSelect
              placeholder="Кампания"
              className="campaign"
              value={parseInt(fields.cid)}
              onChange={onCampaignChange}
            />
            <CampaignOverview
              info={campaignInfo}
              loading={campaignInfoLoading}
            />
          </div>
        </SecondaryHeader>
      </FixedHeader>
      <div className="content-body content-body__with-fixed-secondary">
        <TeaserForm
          fields={fields}
          onChange={onChange}
          errors={errors}
          campaignInfo={campaignInfo}
          aiTitlesLoading={aiTitlesLoading}
          handleTitleGenerate={handleTitleGenerate}
          aiTitles={aiTitles}
          allowAiTitles={true}
        />
      </div>
    </div>
  );
};

export default TeaserAggregatorForm;
